import { FC,useState, useEffect,  useMemo  } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { Link } from '@react-navigation/native';
import { Link } from 'react-router-dom';
import moment from "moment";
import $ from 'jquery';


const CompanyDirectory: FC = () => {
      const intl = useIntl();
      const ITEMS_PER_PAGE = 10; 
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      //const [companyList, setCompanyList] = useState([]);
      const [companyList, setCompanyList] = useState<any[]>([]);

      const Pagesize=10;
      const siteId = '2';
      
      function validateCheck() {
        //alert("test");
      } 

      useEffect(() => {
        validateCheck();
        getAdminProfilesList(ITEMS_PER_PAGE,'1');   
      }, []);

      function getAdminProfilesList(ITEMS_PER_PAGE:any,pageNumber:any)
      {   
        var searchTxt:any = $('#search_input').val();
        var encoded_queryval = encodeURIComponent(searchTxt.trim());
        var statuschk = 'published';
        var sortBy = '';
        var sortDir='';
        
        services.adminGetCompanyList(siteId,ITEMS_PER_PAGE,pageNumber,encoded_queryval,statuschk,sortBy,sortDir).then((res) => 
        {
            console.log("#######################");
            console.log(JSON.stringify(res));
            
            if(res.data){
              console.log(JSON.stringify(res));
              setTotalItems(res.data.totalElements);         
              settotalPages(Math.ceil(res.data.totalElements / ITEMS_PER_PAGE));            
              setCurrentPage(pageNumber);
              setCompanyList(res.data.content);   
            }
              
        
        });
    }

    const searchList = () => {
      getAdminProfilesList(ITEMS_PER_PAGE,'1');  
    } 

      const handlePageChange2 = (offset:any,triggerevent:any) => {
        getAdminProfilesList(ITEMS_PER_PAGE,offset);
      };
      
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Company Directory'})}</PageTitle>

          <div className={`card`}>
     
     {/* begin::Body */}
     <div className='card-body py-3'>
       {/* begin::Table container */}
       <div className='table-responsive'>
       <table className=''>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>                
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" onChange={searchList}/> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
            
         {/* begin::Table */}
         <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
           {/* begin::Table head */}
           <thead>
             <tr className='fw-bolder text-muted'>
               {/* <th className='w-25px'>
                 <div className='form-check form-check-sm form-check-custom form-check-solid'>
                   <input
                     className='form-check-input'
                     type='checkbox'
                     value='1'
                     data-kt-check='true'
                     data-kt-check-target='.widget-13-check'
                   />
                 </div>
               </th> */}
             
               <th className='min-w-120px'>Company Name</th>            
               {/* <th className='min-w-120px'>Email</th>  */}
               <th className='min-w-120px'>Phone Number</th> 
               <th className='min-w-100px text-end'>Actions</th>
             </tr>
           </thead>
           {/* end::Table head */}
           {/* begin::Table body */}
           <tbody>

           {	
	          companyList.map((data, index) => (

             <tr>
               {/* <td>
                 <div className='form-check form-check-sm form-check-custom form-check-solid'>
                   <input className='form-check-input widget-13-check' type='checkbox' value='1' />
                 </div>
               </td> */}
              
               <td>
                 {/* <a href={'/companyDetails?companyId='+data.companyId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                {data.name}
                 </a> */}

                 {/* <Link to={{ screen: 'editcompany', params: { companyId: data.companyId } }}>
                 {data.name}
    </Link> */}
              <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/companyDetails?companyId='+data.companyId}>{(data.name=='' || data.name==null) ? '--' : data.name} </Link>
                
               </td>
               {/* <td>
                

<Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/companyDetails?companyId='+data.companyId}> {data.email}</Link>
                
               </td> */}
               <td>
                 {/* <a href={'/companyDetails?companyId='+data.companyId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                 {data.phoneno}
                 </a> */}

                <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/companyDetails?companyId='+data.companyId}>{(data.phoneno=='' || data.phoneno==null) ? '--' : data.phoneno} </Link>
                
               </td>
             
           
             
               <td className='text-end'>
                 {/* <a
                   href='#'
                   className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                 >
                   <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
                 </a> */}
                 {/* <a
                   href={'/companyDetails?companyId='+data.companyId}
                   className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                 >
                   <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                 </a> */}


                 <Link className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' to={'/companyDetails?companyId='+data.companyId}>
                 <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                 </Link>

                 {/* <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                   <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                 </a> */}
               </td>
             </tr>
              ))}
             
           </tbody>
           {/* end::Table body */}
         </table>

         <Pagination
               
               total={totalItems}
               itemsPerPage={ITEMS_PER_PAGE}
               currentPage={currentPage}
               onPageChange={handlePageChange2}

               /> 
        
         {/* end::Table */}
       </div>
       {/* end::Table container */}
     </div>
     {/* begin::Body */}
   </div>

         
        </>
      )
    }
export {CompanyDirectory}